import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardProps,
  styled,
} from '@mui/material';

interface iAppCard extends CardProps {
  children: React.ReactNode;
  title?: string;
}

const MuiCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(7, 7),
  borderRadius: 4,
  boxShadow: '0 15px 35px 0 #3c425714,0 5px 15px 0 #0000001f',

  // responsive
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 4),
  },

  '& .MuiCardHeader-root': {
    padding: 0,

    '& .MuiCardHeader-title': {
      fontSize: 24,
      fontWeight: 600,
    },
  },

  '& .MuiCardContent-root': {
    padding: '0!important',
  },
}));

const AppCard: React.FC<iAppCard> = ({ children, title }) => {
  return (
    <MuiCard>
      {title && <CardHeader title={title} />}
      <CardContent>{children}</CardContent>
    </MuiCard>
  );
};

export default AppCard;
